import { apiCall } from "./service";
import {
  URL_PORTFOLIO,
  URL_CREATE_PORTFOLIO,
  URL_UPDATE_PORTFOLIO,
  URL_SEARCH_PORTFOLIO,
  URL_CLIENT,
  URL_CLIENT_PORTFOLIOS,
  URL_SORT_CLIENT_PORTFOLIOS,
  URL_DELETE_PORTFOLIO,
  URL_SEARCH_CLIENT_PORTFOLIO,
  URL_PORTFOLIO_FLAG,
  BASE_URL,
} from "./URL";

export const api = {
  // getPortfolioDetailsRequest(params) {
  //   if (params.id) return apiCall.pagination({url: `${URL_CLIENT}${params.id}${URL_CLIENT_PORTFOLIOS}?pageNumber=${params.page}&pageSize=${params.size}`, isAuthToken: true, params });
  //   return apiCall.pagination({url: `${URL_PORTFOLIO}?pageNumber=${params.page}&pageSize=${params.size}`, isAuthToken: true, params});
  // },
  portfolioRequest(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url;

    switch (parent) {
      case "Client":
        url = `${BASE_URL}Clients/${id}/Portfolios`;
        break;

      default:
        url = `${BASE_URL}Portfolios`;
    }

    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;

    return apiCall.pagination({ url: fullUrl });
  },

  getPortfolioDetails(params) {
    if (params.id) {
      return apiCall.get({
        url: `${URL_PORTFOLIO}/${params.id}`,
        isAuthToken: true,
        params,
      });
    }
  },

  // portfolioRequest(params) {
  //   return apiCall.pagination({url: `${URL_PORTFOLIO}?pageNumber=${params.page}&pageSize=${params.size}`,isAuthToken: true, params});
  // },

  createPortfolioRequest(params) {
    return apiCall.post({
      url: `${URL_CREATE_PORTFOLIO}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  sortPortfoliosRequest(params) {
    if (params.id)
      return apiCall.pagination({
        url: `${URL_CLIENT}${params.id}${URL_CLIENT_PORTFOLIOS}?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
        params,
      });
    return apiCall.pagination({
      url: `${URL_SORT_CLIENT_PORTFOLIOS}?pageNumber=${params.page}&pageSize=${params.size}&orderby=${params.orderBy}`,
      isAuthToken: true,
    });
  },

  searchPortfolioDataRequest(params) {
    return apiCall.get({ url: `${URL_SEARCH_PORTFOLIO}${params}` });
  },

  searchPortfoliosRequest(params) {
    return apiCall.get({
      url: `${URL_SEARCH_CLIENT_PORTFOLIO}?clientId=${params.id}&searchTerm=${params.searchText}`,
      isAuthToken: true,
    });
  },

  updatePortfolioRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_PORTFOLIO}/${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  deletePortfolioRequest(params) {
    return apiCall.delete({ url: `${URL_DELETE_PORTFOLIO}${params.id}` });
  },

  updatePortfolioFlagRequest(params) {
    return apiCall.patch({
      url: `${URL_PORTFOLIO_FLAG}/${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },
  getPortfolioBudgetSummaryRequest(params) {
    if (params.id) {
      return apiCall.get({
        url: `${URL_PORTFOLIO}/${params.id}/budget-summary`,
        isAuthToken: true,
        params,
      });
    }
  },
  getPortfolioProgressSummaryRequest(params) {
    if (params.id) {
      return apiCall.get({
        url: `${URL_PORTFOLIO}/${params.id}/progress-summary`,
        isAuthToken: true,
        params,
      });
    }
  },
  ganttReportRequest(id, payload) {
    return apiCall.pdfPost({
      url: `${URL_PORTFOLIO}/${id}/gantt-report`,
      params: payload,
    });
  },

  getTeam(id) { 
    return apiCall.get({url: `${URL_PORTFOLIO}/${id}/Detailed-Resources`});
  },
};

export default api;
